/* ===== Ninja Star Fly-out System ===== */

/* Lightning trigger — relative when inside a positioned container */
.lightning-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: hsla(var(--primary) / 0.12);
  border: 1px solid hsla(var(--primary) / 0.35);
  border-radius: 9999px;
  color: hsl(var(--primary));
  cursor: pointer;
  user-select: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0;
  line-height: 1;
  flex-shrink: 0;
}

/* Shared flyout host — positioning is per variant (do not put top/right here:
 * chat uses position:relative, and leftover top/right offsets the trigger) */
.ninja-star-container {
  z-index: 30;
}

/* Task cards: absolutely pinned top-right of card */
.ninja-star-container--task {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: var(--ninja-corridor, 360px);
  margin-left: calc(-1 * var(--ninja-corridor, 360px));
}

.ninja-star-container--task .lightning-trigger {
  position: relative;
  top: auto;
  right: auto;
}

.ninja-star-trigger-slot {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  position: relative;
}

/* Anchor flyout at the trigger (right edge), fan items leftward */
.ninja-star-container--task .ninja-star-items {
  position: absolute;
  top: 50%;
  right: 36px;
  left: auto;
  transform: translateY(-50%);
  --gap: 44px;
}

/* Chat header: trigger and flyout use theme (primary) */
.ninja-star-container--chat .lightning-trigger {
  background: hsl(var(--primary) / 0.15);
  border-color: hsl(var(--primary) / 0.4);
  color: hsl(var(--primary));
  box-shadow: 0 4px 12px hsl(var(--primary) / 0.15);
  position: relative;
  top: auto;
  right: auto;
}

/* Chat header + Cortex composer: inline flex, expands leftward for the flyout */
.ninja-star-container--chat {
  position: relative;
  top: auto;
  right: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: center;
  height: 32px;
  min-width: 32px;
  /* Corridor for leftward flyout hover — does not affect sibling spacing */
  padding-left: 220px;
  margin-left: -220px;
}

/* Chat: flyout items panel — sits to the LEFT of the lightning trigger */
.ninja-star-container--chat .ninja-star-items {
  top: 50%;
  right: 36px;
  left: auto;
  transform: translateY(-50%);
  --gap: 36px;
}

.ninja-star-container--chat .ninja-item {
  --gap: 36px;
}

.ninja-star-container--chat .ninja-item button,
.ninja-star-container--chat .ninja-item .ninja-flyout-control {
  width: 32px;
  min-width: 32px;
  height: 32px;
  border-radius: 9999px;
}

/* Composer toolbar: circular icon buttons match chat header */
.ninja-star-container--chat .ninja-flyout-control > button {
  width: 32px;
  min-width: 32px;
  height: 32px;
  border-radius: 9999px;
}

/* Flyout slot container (default anchor — overridden per variant above) */
.ninja-star-items {
  position: absolute;
  top: 50%;
  right: 36px;
  transform: translateY(-50%);
  pointer-events: none;
  width: 0;
  height: 32px;
  --gap: 44px;
}

/* Individual flyout slots — hidden until container is hovered or pinned open */
.ninja-item {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateX(12px) scale(0.8);
  transition:
    transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1),
    opacity 0.2s ease,
    visibility 0.2s ease;
  transition-delay: calc(var(--i, 1) * 25ms);
  --gap: 44px;
}

/* Open: hover corridor, data-open from React, or keyboard focus-within */
.ninja-star-container:hover .ninja-item,
.ninja-star-container[data-open='true'] .ninja-item,
.ninja-star-container:focus-within .ninja-item {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(calc(-1 * var(--i, 1) * var(--gap))) scale(1);
}

.ninja-star-container[data-open='true'] .lightning-trigger,
.ninja-star-container:hover .lightning-trigger {
  background: hsla(var(--primary) / 0.2);
  border-color: hsla(var(--primary) / 0.5);
}

/* Flyout buttons — filled primary circles (task cards + chat header panels) */
.ninja-star-container--task .ninja-item button,
.ninja-star-container--chat:not(.ninja-star-container--composer) .ninja-item > button {
  min-width: 32px;
  width: 32px;
  height: 32px;
  padding: 0 !important;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: hsl(var(--primary)) !important;
  color: hsl(var(--primary-foreground)) !important;
  border: 1px solid hsl(var(--primary) / 0.4) !important;
  backdrop-filter: blur(8px);
  transition: background 0.2s ease, transform 0.2s ease;
}

/* Composer: preserve Button variant styling (web search blue, specialist active, etc.) */
.ninja-star-container--composer .ninja-item button {
  min-width: 32px;
  width: 32px;
  height: 32px;
  padding: 0 !important;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ninja-star-container--task .ninja-item button:hover,
.ninja-star-container--chat:not(.ninja-star-container--composer) .ninja-item > button:hover {
  background: hsl(var(--primary) / 0.9) !important;
  transform: scale(1.05);
}

.ninja-item button svg {
  flex-shrink: 0;
}

/* Remove legacy pseudo lightning bolt */
.task-card-webview::after {
  content: none !important;
  display: none !important;
}

/* Remove debug visuals if they exist */
.task-card-webview .flex.items-center.gap-1 {
  border: none !important;
  background: transparent !important;
  opacity: 1 !important;
}
